<div class="the-woods-properties">
  <ng-container
    *rxFor="let property of viewModel.propertiesBasedOnPools$; strategy: 'immediate'; let i = index"
    class="the-woods-product-property">
    <div class="property-name">{{ property?.title }}</div>
    <div></div>
    <div
      appPrintCardScaleDownText
      [maxWidthInPx]="70"
      [transparentWhileScaling]="viewingInLiveView"
      class="property-value">
      {{ property?.value }}
    </div>
    <div *ngIf="i % 2 === 0"></div>
  </ng-container>
</div>
